import { useEffect, useState } from 'react'
import { ChevronUp } from 'lucide-react'

export default function BackToTop() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300)
    window.addEventListener('scroll', onScroll)
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <button
      aria-label="Back to top"
      onClick={scrollToTop}
      className={`fixed bottom-6 right-6 z-50 rounded-full text-white shadow-lg p-3 transition-all duration-200 hover:opacity-90 ${visible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      style={{background: '#006D77'}}
    >
      <ChevronUp className="h-5 w-5" />
    </button>
  )
}
